import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app/App";
import { GraphDataProvider } from "./app/GraphDataContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./design/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("PWEB root element is missing.");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <GraphDataProvider><App /></GraphDataProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
